import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withKeys as _withKeys, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/home/logo-transparent.png'


const _withScopeId = n => (_pushScopeId("data-v-5f0a75b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-menu" }
const _hoisted_2 = { class: "logo position-absolute start-0 end-0 top-0 division-company-name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Fin",
  width: "42"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "company-name fw-bold ms-10 fs-16" }, "Fin", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bb-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-x" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block support-menu-button"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-whatsapp-logo" }),
    /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Suporte")
  ])
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "mobile-bottom-menu" }
const _hoisted_13 = { class: "mobile-bottom-icon" }
const _hoisted_14 = { class: "mobile-bottom-label" }
const _hoisted_15 = ["aria-expanded"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mobile-bottom-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-dots-three" })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mobile-bottom-label" }, "Ver mais", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mobile-more-sheet__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_20 = { class: "mobile-more-sheet__header" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mobile-more-sheet__eyebrow" }, "Navegação"),
  /*#__PURE__*/_createElementVNode("h2", { id: "mobileMoreMenuTitle" }, "Ver mais")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-x" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "mobile-more-sheet__actions" }
const _hoisted_25 = { class: "mobile-more-sheet__action-icon" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-right mobile-more-sheet__arrow" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mobile-more-sheet__action-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sair"),
  /*#__PURE__*/_createElementVNode("small", null, "Encerrar a sessão neste dispositivo")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-right mobile-more-sheet__arrow" }, null, -1))
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
      id: "sidebar-area"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("button", {
            class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _hoisted_7)
        ]),
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleItems, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.key,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: item.path,
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "aria-current": _ctx.isActive(item.path) ? 'page' : undefined
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isActive(item.path) })
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(item.icon)
                    }, null, 2),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.label), 1)
                  ], 2)
                ]),
                _: 2
              }, 1032, ["to", "aria-current"])
            ]))
          }), 128)),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSupportWhatsapp && _ctx.openSupportWhatsapp(...args))),
            class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          }, _hoisted_11)
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("nav", {
        class: "mobile-bottom-nav",
        "aria-label": "Menu principal mobile",
        style: _normalizeStyle({ gridTemplateColumns: `repeat(${_ctx.mobilePrimaryItems.length + 1}, minmax(0, 1fr))` })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobilePrimaryItems, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.key,
            to: item.path,
            class: _normalizeClass(["mobile-bottom-link", { active: _ctx.isActive(item.path) }]),
            "aria-current": _ctx.isActive(item.path) ? 'page' : undefined
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2)
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(item.mobileLabel || item.label), 1)
            ]),
            _: 2
          }, 1032, ["to", "class", "aria-current"]))
        }), 128)),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["mobile-bottom-link mobile-more-button", { active: _ctx.moreMenuOpen || _ctx.isMoreRouteActive }]),
          "aria-label": "Ver mais opções",
          "aria-controls": "mobileMoreMenu",
          "aria-expanded": _ctx.moreMenuOpen,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moreMenuOpen = true))
        }, _hoisted_18, 10, _hoisted_15)
      ], 4)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.moreMenuOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "mobile-more-backdrop",
            "aria-hidden": "true",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeMoreMenu && _ctx.closeMoreMenu(...args)))
          }))
        : _createCommentVNode("", true),
      (_ctx.moreMenuOpen)
        ? (_openBlock(), _createElementBlock("section", {
            key: 1,
            id: "mobileMoreMenu",
            class: "mobile-more-sheet",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "mobileMoreMenuTitle",
            onKeydown: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeMoreMenu && _ctx.closeMoreMenu(...args)), ["esc"]))
          }, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("button", {
                type: "button",
                class: "mobile-more-sheet__close",
                "aria-label": "Fechar",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeMoreMenu && _ctx.closeMoreMenu(...args)))
              }, _hoisted_23)
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreNavigationItems, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.key,
                  to: item.path,
                  class: "mobile-more-sheet__action",
                  onClick: _ctx.closeMoreMenu
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_25, [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon)
                      }, null, 2)
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(item.moreLabel || item.label), 1),
                      _createElementVNode("small", null, _toDisplayString(item.moreDescription), 1)
                    ]),
                    _hoisted_26
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"]))
              }), 128)),
              _createElementVNode("button", {
                type: "button",
                class: "mobile-more-sheet__action is-danger",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.requestLogout && _ctx.requestLogout(...args)))
              }, _hoisted_30)
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}